import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";


function Registration() {
  const location = useLocation();


    const handleClick1 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };
     const handleClick2 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };
     const handleClick3 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };
      const handleClick4 = () => {      
  window.open('https://docs.google.com/forms/d/e/1FAIpQLSc1wy9qQ3Hdiz7HipbozUxvNZwFAhSG4vsCtVtPmP_l8WIH9g/viewform', '_blank');
};
      const handleClick5 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSd20D8uhIulksZgq5NcD0Q1Jte71dKmUCCQFtHZ4fdI5PuAeQ/viewform');
  };
      const handleClick6 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSd20D8uhIulksZgq5NcD0Q1Jte71dKmUCCQFtHZ4fdI5PuAeQ/viewform');
  };

      const handleClick7 = () => {
   window.open('https://docs.google.com/forms/d/e/1FAIpQLSfw79a85sHFn3zXedEE8bfWOwSPc82VZ28drPHTPhJm2eJG9w/viewform');
  };
      const handleClick8 = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSfyUZt4peUyGezMs72Taa9NH0s-IayV7VJpHF8kV7YQbZ1tpg/viewform');
  };



  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div className="w-full min-h-screen text-gray-900 font-sans" style={{ paddingTop: "6rem" }}>
      {/* Header */}
      <header
        className="text-center py-8 border-b-4 border-yellow-400"
        style={{ backgroundColor: "#047180" }}
      >
        <h1 className="text-4xl font-extrabold tracking-wide text-white">
          PROGRAM REGISTRATIONS
        </h1>
      </header>

      {/* SmartLAB Section */}
      <section 
      id="afterschool-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-blue-600 mb-4">SmartLAB</h2>
            <p className="text-lg font-semibold text-gray-700 mb-2">
              TECH & HOMEWORK
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Power Up Young Minds. <br /> Plug Into the Future.
            </p>
            <button onClick={handleClick1} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              REGISTER HERE!
            </button>
            <p className="mt-4 text-sm">
              info@choicestfruit.com
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-2">LEARN:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>📚 Homework Help: Math, reading, and science support</li>
              <li>💻 Tech Time: Coding, electronics, and robotics</li>
              <li>🎮 Creative Projects: Games, animations, circuits</li>
              <li>💬 Teamwork: Problem-solving and communication</li>
              <li>💼 Career Exposure: Tech jobs and entrepreneurial skills</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                SmartLAB is an after-school and weekend program for kids and teens
                (ages 8–17) living in apartment community. We mix fun with
                learning to build brainpower, creativity, and tech skills!
              </p>
              <p className="mt-2 font-semibold text-gray-800">
                OPEN TO: AGES 8–17 IN THE APARTMENT COMPLEX
              </p>
              <p className="mt-1 text-sm text-gray-600">
                Serving Hays and Travis County
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Senior Tech Club Section */}
      <section 
      id="seniors-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-green-600 mb-4">Smart & Sharp</h2>
            <p className="text-lg font-semibold text-gray-700 mb-2">
              SENIOR TECH CLUB
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Build Confidence. <br /> Boost Memory. <br /> Create & Connect.
            </p>
            <button onClick={handleClick2} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              REGISTER HERE!
            </button>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-2">LEARN:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>🧠 Digital Life Skills: Messaging, smart devices, finance, health</li>
              <li>🛡 Safety & Independence: Protection, awareness, autonomy</li>
              <li>🎨 Memory Wellness & Creativity: Storytelling, reflection, joy</li>
              <li>🌍 Discovery & Build: Explore, create, and build with tech</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                Smart & Sharp is a fun, hands-on weekly tech club for seniors to
                explore everyday technology, improve memory, and even build
                electronic gadgets with tools like Arduino and basic computer parts.
                No experience needed—just curiosity!
              </p>
              <p className="mt-2 font-semibold text-gray-800">
                PERFECT FOR: ADULTS 60+ · TOTAL BEGINNERS WELCOME
              </p>
              <p className="mt-1 text-sm text-gray-600">
                Serving Hays and Travis County
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Code and Soil Section */}
      <section 
      id="codesoil-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-lime-700 mb-4">Code &amp; Soil</h2>
              <p className="text-lg font-semibold text-gray-700 mb-2">
              NEIGHBORHOOD CLUB
            </p>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Grow Minds. Grow Plants. Grow Skills.
            </p>
            <button onClick={handleClick3} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              REGISTER HERE!
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  <li>✅ Certificates of Completion</li>
                  <li>✅ Digital Skill Badges</li>
                  <li>✅ Alumni Network for ongoing peer support</li>
                </ul>
              </div>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">LEARN:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>🌱 Gardening: Plant seeds, care for plants, harvest, and explore the science behind growth</li>
              <li>💻 Tech & Robotics: Learn coding basics, create simple software tools, and use robotics to automate garden tasks</li>
              <li>💼 Entrepreneurship: Sell the plants you grow, learning pricing, marketing, and business skills</li>             
              <li>💬 Teamwork & Challenges: Collaborate with peers to problem-solve and innovate</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                Code &amp; Soil is a hands-on program where youth blend gardening, coding, and entrepreneurship—growing plants, using robotics to enhance projects, and building business skills by selling their harvest. It fosters sustainability, creativity, and real-world skills in a fun, supportive environment.
              </p>             
              <p className="mt-2 font-semibold text-gray-800">
                AGES: 8–17 in the neighborhood
              </p>
              <p className="mt-1 text-sm text-gray-600">
                OPEN TO: Residents and neighborhood children interested in gardening, tech, and entrepreneurship
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Ambassador Program Section */}
      <section
        id="ambassador-section"
        className="py-12 px-4 md:px-6 flex justify-center"
      >
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-purple-700 mb-4">Ambassador Program</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Lead. Inspire. Transform Communities.
            </p>
            <button onClick={handleClick4} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              APPLY HERE!
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  <li>✅ Certificates of Completion</li>
                  <li>✅ Digital Skill Badges</li>
                  <li>✅ Alumni Network for ongoing peer support</li>
                </ul>
              </div>
            <p className="mt-4 text-sm">
              info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">LEARN &amp; DO:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>💻 Tech Leadership: Facilitate workshops, mentor peers, and bring tech skills to new communities</li>
              <li>🌱 Community Impact: Apply technology to solve real-world challenges in schools, neighborhoods, and online spaces</li>
              <li>🎨 Innovation & Creativity: Design projects that make tech accessible, engaging, and meaningful</li>
              <li>💬 Collaboration & Influence: Work with other ambassadors to model leadership, inclusion, and teamwork</li>
              <li>🚀 Opportunity Building: Create programs, events, and initiatives that empower others to thrive in tech</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                The Ambassador Program empowers youth to lead, mentor, and innovate in tech. Ambassadors help peers and communities access hands-on STEM, guide others in digital skills, and extend Choicest Fruit®’s mission for lasting impact.
              </p>
              <p className="mt-2 font-semibold text-gray-800">
                YOUTH AGES: 14–24
              </p>
              <p className="mt-1 text-sm text-gray-600">
                OPEN TO: Students and young adults interested in leadership, technology, and community service
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Internship Program Section */}
      <section 
       id="internship-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-cyan-700 mb-4">Internships</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Hands-On Projects. Real-World Impact.
            </p>
            <button onClick={handleClick5} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              APPLY HERE!
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  <li>✅ Certificates of Completion</li>
                  <li>✅ Digital Skill Badges</li>
                  <li>✅ Alumni Network for ongoing peer support</li>
                </ul>
              </div>
            <p className="mt-4 text-sm">
             info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">LEARN &amp; DO:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>💡 Tech Accessibility: Build smart assistive devices for seniors, people with disabilities, underrespresented communities and inclusive learning apps</li>
              <li>🌿 Urban Farming & Sustainability: Create IoT smart gardens, hydroponics systems, and eco-friendly 3D printing solutions</li>
              <li>⚙️ Electronics & Software Development: Work with Arduino, sensors, microcontrollers, Python, C++, and web & app development</li>
              <li>🤖 AI & Smart Solutions: Explore predictive monitoring, adaptive learning, automated gardening, and AI-powered design tools</li>
            
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                Choicest Fruit® internships let youth (14–24) apply STEM skills to real projects—learning, prototyping, and deploying solutions in tech accessibility, urban farming, and environmental innovation.
              </p>
              <p className="mt-2 font-semibold text-gray-800">
                YOUTH AGES: 14–24
              </p>
              <p className="mt-1 text-sm text-gray-600">
                OPEN TO: Students and young adults passionate about STEM, sustainability, and tech for good
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Tech-Pal Program Section */}
      <section 
      id="techpal-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-sky-700 mb-4">Tech-Pal Program</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Peer Mentoring. Cross-Cultural Learning. Real-World Projects.
            </p>
            <button onClick={handleClick6} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              APPLY HERE!
            </button>
             <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  <li>✅ Certificates of Completion</li>
                  <li>✅ Digital Skill Badges</li>
                  <li>✅ Alumni Network for ongoing peer support</li>
                </ul>
              </div>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">LEARN &amp; COLLABORATE:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>💡 Software &amp; Coding: Build apps, websites, and accessible digital solutions using JavaScript, Python, and beginner-friendly tools</li>
              <li>🌿 Electronics &amp; IoT: Design smart devices, sensor-based gardens, and microcontroller projects</li>
              <li>🛡️ Cybersecurity Awareness: Learn safe coding practices, data privacy, and secure IoT systems</li>
              <li>🤝 Leadership &amp; Mentoring: Develop teamwork, communication, and problem-solving skills through peer mentoring</li>
              <li>🎨 Innovation &amp; Showcase: Create projects with tangible social impact, present them, and celebrate achievements</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                The Tech-Pal Program pairs youth from Choicest Fruit® with peers from around the world (ages 14–24) to build technical, leadership, and collaboration skills. Participants work on real-world projects, mentor each other, and gain hands-on experience in software development, electronics, and cybersecurity.
              </p>
             
              <p className="mt-2 font-semibold text-gray-800">
                YOUTH AGES: 14–24
              </p>
              <p className="mt-1 text-sm text-gray-600">
                OPEN TO: Tech-curious students around the world eager to learn, mentor, and collaborate on impactful projects
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Educator Workshops Section */}
      <section 
      id="workshops-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-orange-700 mb-4">Educator Workshops</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Professional Development. EdTech Skills. Ethical Innovation.
            </p>
            <button onClick={handleClick7} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              REGISTER HERE!
            </button>
            <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  <li>✅ Certification of Attendance</li>
                  <li>✅ Resources & Templates for Classroom Implementation</li>
                  <li>✅ Follow-up Support and Consultation</li>
                </ul>
              </div>
            <p className="mt-4 text-sm">
               info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">LEARN &amp; EXPLORE:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>💻 EdTech Tools: Hands-on experience with coding platforms, AI basics, and classroom tech integration</li>
              <li>🧠 Ethical Technology: Understand the societal and moral impact of technology and how to guide students responsibly</li>
              <li>📊 Practical Classroom Applications: Learn to design lessons, projects, and activities that engage students in tech and innovation</li>
              <li>🤝 Collaboration & Networking: Connect with peers, share ideas, and develop best practices for modern classrooms</li>
              <li>🌟 Continued Learning & Certification: Gain insights aligned with PD standards and continuing education credit opportunities</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                Choicest Fruit® Educator Workshops provide teachers and school staff with interactive, practical sessions to enhance their skills in EdTech, coding, AI, and ethical tech practices. These workshops equip educators to integrate technology effectively in their classrooms while fostering creativity, critical thinking, and digital citizenship among students.
              </p>
              <p className="mt-1 text-sm text-gray-600">
                OPEN TO: Teachers, administrators, and education professionals seeking hands-on tech training and professional growth
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="flex justify-center">
        <hr className="border-t-4 border-yellow-400 w-full max-w-5xl" />
      </div>

      {/* Tech Camps Section */}
      <section 
      id="techcamps-section"
      className="py-12 px-4 md:px-6 flex justify-center">
        <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-5xl grid md:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="text-3xl font-bold text-teal-700 mb-4">Tech Camps</h2>
            <p className="text-2xl font-bold text-gray-900 mb-6">
              Innovate. Code. Build. Explore.
            </p>
            <button onClick={handleClick8} className="bg-yellow-400 text-black font-bold py-3 px-6 rounded-lg shadow-md hover:bg-yellow-500">
              REGISTER HERE!
            </button>
            <div className="mt-2">
           
                <ul className="custom-list pl-0 text-sm mt-1">
                  <li>✅ Project Showcases for Parents and Community</li>
                  <li>✅ Certificates of Completion</li>
                  <li>✅ Access to Online Resources & Challenges</li>
                </ul>
              </div>
            <p className="mt-4 text-sm">
              info@choicestfruit.com
            </p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-2">LEARN &amp; EXPLORE:</h3>
            <ul className="custom-list pl-0 space-y-2">
              <li>💻 Coding &amp; App Development: Hands-on projects in JavaScript, Python, and beginner-friendly platforms</li>
              <li>🤖 Robotics &amp; Electronics: Build circuits, simple robots, and interactive tech projects</li>
              <li>🎮 Creative Tech: Design games, animations, or digital art while learning tech fundamentals</li>
              <li>🌱 STEM &amp; Sustainability Projects: Apply tech skills to real-world challenges like urban gardening or environmental solutions</li>
              <li>🤝 Teamwork &amp; Problem-Solving: Collaborate in small groups to complete challenges and showcase projects</li>
            </ul>
            <div className="mt-6">
              <h3 className="text-xl font-bold mb-2">WHAT IT IS:</h3>
              <p>
                Choicest Fruit® Tech Camps are immersive, multi-day or week-long programs for kids and teens (ages 8–17) that combine fun, creativity, and hands-on learning. Participants gain foundational skills in coding, electronics, and problem-solving while exploring technology’s potential to impact communities.
              </p>
              <p className="mt-1 text-sm text-gray-600">
                OPEN TO: Children and youth interested in tech, coding, robotics, and creative problem-solving
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Registration;
